module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drop-area",
    class: _vm.classList,
    on: {
      "dragenter": function($event) {
        $event.preventDefault();
        return _vm.setHover(true)
      },
      "dragover": function($event) {
        $event.preventDefault();
        return _vm.setHover(true)
      },
      "dragleave": function($event) {
        $event.preventDefault();
        return _vm.setHover(false)
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.drop.apply(null, arguments)
      }
    }
  }, [_c('form', {
    staticClass: "my-form"
  }, [_c('h5', [(_vm.uploadSuccess) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check_circle")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.title))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('input', {
    staticClass: "fileElem",
    attrs: {
      "type": "file",
      "name": "fileElem",
      "id": _vm.id,
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        return _vm.filesSelected.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (!_vm.uploading) ? _c('label', {
    staticClass: "button",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v("Select some files")]) : _vm._e(), _vm._v(" "), (!_vm.uploading) ? _c('label', [_vm._v("or drop some files here")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gallery"
  }, [_vm._t("gallery", function() {
    return [_c('div', _vm._l((_vm.images), function(img, index) {
      return _c('img', {
        key: index,
        staticClass: "img",
        attrs: {
          "src": img
        }
      })
    }), 0)]
  }, {
    "images": _vm.images
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "disabled": !_vm.file,
      "loading": _vm.uploading,
      "color": "primary",
      "block": ""
    },
    on: {
      "click": _vm.uploadFile
    }
  }, [_c('v-icon', [_vm._v("file_upload")]), _vm._v(" Upload")], 1)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-556e172a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/media/Uploader.vue
// module id = 1428
// module chunks = 9